import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BtnComponent } from '../../components/button';
import { InputField } from '../../components/reactHookFormFields/inputField';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { forgotPassword, resetPassword } from '../../services/login';
import ethizologo from "../../assets/images/logo-login.svg";
import { Input } from '../../components/reactHookFormFields/input';

const ResetPassword = () => {

    const navigate = useNavigate();
    const[isSubmitting, setIsSubmitting] = useState(false);
    const { token } = useParams(); // Extract token from URL
    console.log("token", token);

    const [inputVisibility, setInputVisibility] = useState(false);
    const [inputVisibilityConfirmPassword, setInputVisibilityConfirmPassword] = useState(false);

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {},
    });


    const handleSubmitForm = (values) => {

        setIsSubmitting(true);
        resetPassword({...values, password_code: token}).then((res) => {
            setIsSubmitting(false);
            if(res?.data?.response.code == 0){
                toast.success(res?.data?.response?.msg);
                navigate('/auth/login');
            }
            else {
                toast.error(res?.data?.response?.msg);
            }
        });
    };


    return (
        <div className='min-h-screen'>
            <div className="flex justify-center items-center pt-4 md:pt-[5rem] py-4">
                <img src={ethizologo} alt="logo" className="w-40"></img>
            </div>
            <div className='w-4/5 md:w-2/3 mx-auto  mt-4 login-container'>
                <div className="flex flex-col md:flex-row items-start gap-4 justify-center ">
                    <div className=" flex-1 w-full h-[20.7rem] md:h-[21.7rem]">
                        <div className="flex min-h-full flex-col lg:px-8">
                            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                                <form className="space-y-6" name="forget_password_form" onSubmit={handleSubmit(handleSubmitForm)}>
                                <div className="mt-2 relative">
                                    <Input
                                        title="New Password"
                                        name="password"
                                        type={inputVisibility ? 'text' : 'password'}
                                        control={control}
                                        rules={{
                                            required: { value: true, message: "Password is required" },
                                            pattern: {
                                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
                                                message: "Password must be 8+ characters with at least one uppercase, one lowercase and one number."
                                            }
                                        }}
                                        errors={errors}
                                    />
                                    <span className='cursor-pointer absolute top-[34px] right-2 text-gray-500' onClick={() => setInputVisibility(!inputVisibility)}>
                                        {!inputVisibility ? <FaEye /> : <FaEyeSlash />}
                                    </span>
                                </div>
                                <div className="mt-2 relative">
                                    <Input
                                        title="Confirm Password"
                                        name="confirm_password"
                                        type={inputVisibilityConfirmPassword ? 'text' : 'password'}
                                        control={control}
                                        rules={{
                                            required: { value: true, message: "Password is required" },
                                            pattern: {
                                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
                                                message: "Password must be 8+ characters with at least one uppercase, one lowercase and one number."
                                            }
                                        }}
                                        errors={errors}
                                    />
                                    <span className='cursor-pointer absolute top-[34px] right-2 text-gray-500' onClick={() => setInputVisibilityConfirmPassword(!inputVisibilityConfirmPassword)}>
                                        {!inputVisibilityConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                                    </span>
                                </div>
                                 
                                    <BtnComponent btnType='primary' type="submit" className="flex w-full justify-center px-3 py-2 text-lg font-bold border border-ethizo_primary rounded-md bg-ethizo_primary text-[14px] text-white hover:bg-primary-hover hover:border-primary-hover" loading={isSubmitting} text="Submit" />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-center py-2 bg-slate-500  rounded-lg rounded-t-none">
                    <div className="text-center">
                        <a href="/auth/login" className="text-white hover:underline">
                            Login
                        </a>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ResetPassword;
